import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DocumentsSections } from "../../../../domain/enums/DocumentsSectionsEnum";

interface UserAgreementContentsProps {
    isEnglish: boolean;
}

const UserAgreementContents: FC<UserAgreementContentsProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="relative w-full">
            {props.isEnglish ? (
                <div className="relative flex flex-col gap-10 w-full">
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph1.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph1.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph1.subparagraph2`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph1.subparagraph3`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.title`)}
                        </p>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph1.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph1.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph1.item2`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph1.item3`)}
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph2.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph2.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph2.item2`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph2.item3`)}
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph3.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph3.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph3.item2`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.subparagraph3.item3`)}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph3.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph3.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph3.subparagraph2`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph3.subparagraph3`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph1`)}
                        </p>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph2.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph2.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph2.item2`)}
                            </p>
                        </div>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph3`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph2`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph3`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph4`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.title`)}
                        </p>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph1.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph1.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph1.item2`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph1.item3`)}
                            </p>
                        </div>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph2`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph7.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph7.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph7.subparagraph2`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph8.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph8.subparagraph1`)}
                        </p>
                    </div>
                    <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.bottomText`)}</p>
                </div>
            ) : (
                <div className="relative flex flex-col gap-10 w-full">
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph1.title`)}
                        </p>
                        <p className="pl-4">{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph1.text1`)}</p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.title`)}
                        </p>
                        <p className="pl-4">{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph2.text1`)}</p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph3.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph3.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph3.subparagraph2`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.title`)}
                        </p>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph1.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph1.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph1.item2`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph1.item3`)}
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph2.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph2.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph2.item2`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph4.subparagraph2.item3`)}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.title`)}
                        </p>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph1.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph1.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph1.item2`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph1.item3`)}
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 pl-4">
                            <p>{t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph2.title`)}</p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph2.item1`)}
                            </p>
                            <p className="pl-4">
                                {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph5.subparagraph2.item2`)}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph2`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph6.subparagraph3`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph7.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph7.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph7.subparagraph2`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph8.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph8.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph8.subparagraph2`)}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <p className="font-[500]">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph9.title`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph9.subparagraph1`)}
                        </p>
                        <p className="pl-4">
                            {t(`documents.${[DocumentsSections.USER_AGREEMENT]}.paragraph9.subparagraph2`)}
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserAgreementContents;
